module.exports = __webpack_public_path__ + "img/arrastrar.baa83662.svg";